export type PostStatus = "发酵中" | "已回应" | "持续跟进" | "出现反转";

export interface Post {
  id: number;
  title: string;
  excerpt: string;
  category: string;
  tag: string;
  status: PostStatus;
  heat: number;
  comment: number;
  time: string;
  cover: string;
}

export const channels = [
  { key: "ent", name: "娱乐圈", count: 218, icon: "ri-star-smile-line" },
  { key: "live", name: "主播网红", count: 164, icon: "ri-mic-line" },
  { key: "biz", name: "商业科技", count: 132, icon: "ri-building-2-line" },
  { key: "soc", name: "社会百态", count: 97, icon: "ri-earth-line" },
];

export const categoryTabs = ["综合", "娱乐圈", "主播网红", "商业科技", "社会百态"];

export const posts: Post[] = [
  {
    id: 1,
    title: "「星光实验室」选秀剪辑争议发酵：导师镜头被删引粉丝声讨",
    excerpt: "一档观察类选秀节目播出后，多位选手的舞台镜头出现明显删减，导师点评环节被大幅压缩，网友质疑节目组刻意安排剧本。目前话题阅读量已破两亿，制片方暂未正面回应。",
    category: "娱乐圈",
    tag: "选秀现场",
    status: "发酵中",
    heat: 9821,
    comment: 3206,
    time: "8 分钟前",
    cover: "https://readdy.ai/api/search-image?query=Studio%20stage%20with%20spotlights%20and%20golden%20warm%20light%20over%20empty%20seats%2C%20dramatic%20red%20curtain%20backdrop%2C%20cinematic%20editorial%20photography%2C%20moody%20and%20atmospheric%2C%20high%20detail&width=900&height=560&seq=cover-ent-01&orientation=landscape",
  },
  {
    id: 2,
    title: "头部美妆主播「阿屿」年货专场被指夸大成分功效，品牌连夜改宣传",
    excerpt: "有美妆博主逐帧对比后发现，某头部主播在年货节带货时对一款面霜的成分功效描述明显超出备案范围。消息发酵后，涉事品牌连夜更换了产品页文案，主播团队称正在核实口播内容。",
    category: "主播网红",
    tag: "带货翻车",
    status: "持续跟进",
    heat: 7640,
    comment: 2418,
    time: "26 分钟前",
    cover: "https://readdy.ai/api/search-image?query=Beauty%20products%20and%20cosmetics%20arranged%20on%20a%20warm%20minimal%20table%20with%20soft%20natural%20light%2C%20editorial%20product%20photography%2C%20neutral%20paper%20background%2C%20high%20detail%20and%20clean%20composition&width=900&height=560&seq=cover-live-01&orientation=landscape",
  },
  {
    id: 3,
    title: "「拾光茶饮」联名营销被指借势翻车：饥饿营销引老顾客集体吐槽",
    excerpt: "新式茶饮品牌推出城市限定联名，上线三分钟即售罄。不少老顾客质疑其为饥饿营销，并要求平台公布真实库存。官方账号回应称补货在路上，但评论区依旧吵成一片。",
    category: "商业科技",
    tag: "营销争议",
    status: "已回应",
    heat: 5321,
    comment: 1804,
    time: "1 小时前",
    cover: "https://readdy.ai/api/search-image?query=Minimal%20milk%20tea%20cups%20on%20a%20warm%20cream%20background%20with%20soft%20shadow%2C%20editorial%20food%20photography%2C%20clean%20and%20bright%2C%20golden%20hour%20lighting%2C%20high%20detail&width=900&height=560&seq=cover-biz-01&orientation=landscape",
  },
  {
    id: 4,
    title: "「静水」员工爆料：年会抽奖实为提前内定，HR 群聊天记录流出",
    excerpt: "一张疑似内部群的聊天截图在社交平台传播，称某互联网公司年会奖品早已内定，现场抽奖只是走流程。公司回应称截图系伪造，已交由法务处理。事件仍在持续发酵。",
    category: "社会百态",
    tag: "职场见闻",
    status: "发酵中",
    heat: 4210,
    comment: 1335,
    time: "2 小时前",
    cover: "https://readdy.ai/api/search-image?query=Modern%20office%20meeting%20room%20at%20dusk%20with%20warm%20lamp%20light%20and%20people%20silhouettes%2C%20cinematic%20editorial%20photography%2C%20warm%20neutral%20tone%2C%20high%20detail&width=900&height=560&seq=cover-soc-01&orientation=landscape",
  },
  {
    id: 5,
    title: "「海屿」演技综艺现场翻车：导师原话被后期消音，字幕疑似替换",
    excerpt: "某演技竞演节目中，一位新人的临场发挥引发导师长时间沉默。成片播出后，观众发现关键点评被消音处理，字幕内容与口型对不上，网友纷纷猜测节目组在掩饰什么。",
    category: "娱乐圈",
    tag: "综艺疑云",
    status: "出现反转",
    heat: 3890,
    comment: 1102,
    time: "3 小时前",
    cover: "https://readdy.ai/api/search-image?query=Theater%20stage%20with%20a%20single%20actor%20under%20spotlight%20and%20dark%20empty%20auditorium%2C%20dramatic%20warm%20rim%20light%2C%20cinematic%20editorial%20photography%2C%20moody%2C%20high%20detail&width=900&height=560&seq=cover-ent-02&orientation=landscape",
  },
  {
    id: 6,
    title: "知识区大V「常理君」被指洗稿：多篇万字长文与旧帖高度重合",
    excerpt: "科普大V被读者扒出多期文案与论坛旧帖高度重合，部分段落几乎逐字复刻。作者回应称系素材整理不当，已下架相关视频并道歉，但掉粉速度仍在持续。",
    category: "主播网红",
    tag: "洗稿风波",
    status: "已回应",
    heat: 3562,
    comment: 984,
    time: "4 小时前",
    cover: "https://readdy.ai/api/search-image?query=Open%20books%20and%20notebooks%20on%20a%20warm%20wooden%20desk%20under%20soft%20desk%20lamp%2C%20study%20room%20atmosphere%2C%20editorial%20photography%2C%20cozy%20and%20warm%2C%20high%20detail&width=900&height=560&seq=cover-live-02&orientation=landscape",
  },
  {
    id: 7,
    title: "科技公司「览际」汽车事故调查报告遭质疑：责任划分被指避重就轻",
    excerpt: "某造车新势力公布事故调查结果后，数据博主对责任划分提出质疑，认为报告回避了辅助驾驶在事故中的实际作用。官方随后补充说明，称将配合监管部门进一步调查。",
    category: "商业科技",
    tag: "科技追问",
    status: "持续跟进",
    heat: 3108,
    comment: 875,
    time: "5 小时前",
    cover: "https://readdy.ai/api/search-image?query=Minimalist%20electric%20vehicle%20in%20a%20warm%20beige%20studio%20with%20soft%20light%20and%20clean%20lines%2C%20editorial%20automotive%20photography%2C%20premium%20and%20modern%2C%20high%20detail&width=900&height=560&seq=cover-biz-02&orientation=landscape",
  },
  {
    id: 8,
    title: "深夜档情感电台主播被曝连麦剧本：台词本照片流出再添实锤",
    excerpt: "一位深夜连麦主播被听众拍到厚厚一本台词脚本，此前动情的倾诉桥段疑似均有剧本。博主本人回应称「为了节目效果有编导」，但不少老听众表示失望。",
    category: "社会百态",
    tag: "人设崩塌",
    status: "发酵中",
    heat: 2940,
    comment: 763,
    time: "6 小时前",
    cover: "https://readdy.ai/api/search-image?query=Retro%20radio%20microphone%20on%20a%20wooden%20desk%20in%20dim%20warm%20night%20light%2C%20nostalgic%20editorial%20photography%2C%20warm%20amber%20tone%2C%20high%20detail&width=900&height=560&seq=cover-soc-02&orientation=landscape",
  },
  {
    id: 9,
    title: "老牌综艺「周末派对」改版遭群嘲：游戏环节被指照搬海外综艺",
    excerpt: "长寿综艺新一季回归，首期游戏环节被观众指出与海外热门综艺高度相似。节目组发长文回应称已购买版权并完成本土化改编，但对「即抄」质疑尚未给出直接证据。",
    category: "娱乐圈",
    tag: "版权争议",
    status: "已回应",
    heat: 2677,
    comment: 690,
    time: "8 小时前",
    cover: "https://readdy.ai/api/search-image?query=Bright%20vibrant%20game%20show%20set%20with%20colorful%20confetti%20and%20warm%20party%20lighting%2C%20energetic%20editorial%20photography%2C%20playful%20and%20fun%2C%20high%20detail&width=900&height=560&seq=cover-ent-03&orientation=landscape",
  },
];

export const breaking = {
  title: "「山海私房菜」主厨被曝视频并非亲手拍摄，代厨传闻引发信任危机",
  excerpt: "一位坐拥千万粉丝的美食博主被前同事爆料，其出镜的烹饪过程多为团队代厨完成，本人仅负责出镜与口播。视频逐个时段对比的剪辑流传后，账号一夜掉粉数十万，团队已两度发声回应。",
  cover: "https://readdy.ai/api/search-image?query=Close%20up%20of%20chef%20hands%20preparing%20wok%20dish%20over%20open%20flame%20with%20steam%20rising%2C%20warm%20kitchen%20lighting%2C%20cinematic%20editorial%20photography%2C%20rich%20and%20appetizing%2C%20high%20detail&width=1200&height=720&seq=breaking-hero&orientation=landscape",
};

export const heatRank = posts
  .map((p) => ({ title: p.title, heat: p.heat, status: p.status }))
  .sort((a, b) => b.heat - a.heat);

export const hotKeywords = [
  "选秀剪辑",
  "带货成分",
  "联名饥饿营销",
  "剧本连麦",
  "洗稿",
  "照搬海外",
  "年会内定",
  "代厨",
];

export interface TimelineEvent {
  time: string;
  title: string;
  desc: string;
  kind: "发酵" | "回应" | "反转" | "进展";
}

export const timelineEvents: TimelineEvent[] = [
  {
    time: "Day 01",
    title: "网传爆料流出",
    desc: "一张聊天截图开始在多个粉丝群流转，指其品牌宣传与备案不符。",
    kind: "发酵",
  },
  {
    time: "Day 02",
    title: "登上热搜主榜",
    desc: "话题阅读量单日破亿，带货回放被逐段拆解，二次传播爆发。",
    kind: "进展",
  },
  {
    time: "Day 03",
    title: "品牌与主播先后发声",
    desc: "品牌方连夜更换宣传文案，主播团队称正在核实并同步报备记录。",
    kind: "回应",
  },
  {
    time: "Day 05",
    title: "出现局部反转",
    desc: "部分时间线被重新比对，网友质疑点出现分化，官方发布完整时间轴。",
    kind: "反转",
  },
  {
    time: "Day 07",
    title: "监管介入跟进",
    desc: "市场监管部门介入，将依据备案材料对宣传内容进行核查，持续更新。",
    kind: "进展",
  },
];

export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "「最近黑料」的信息从哪里来？",
    a: "我们会综合公开的媒体报道、官方回应、品牌与当事人声明以及社交平台的公开讨论进行梳理，并标注每条信息对应的出处与阶段，尽量帮助读者区分事实、猜测与已有回应。",
  },
  {
    q: "事件出现反转时，网站会怎么更新？",
    a: "一旦当事人、品牌方或监管机构发布新声明，或出现能改变事件走向的新证据，我们会第一时间补充进对应事件的时间线，并更新状态标签（发酵中 / 已回应 / 持续跟进 / 出现反转）。",
  },
  {
    q: "如何快速找到某件正在跟进的事？",
    a: "你可以使用顶部搜索框按关键词检索，也可以根据栏目（娱乐圈 / 主播网红 / 商业科技 / 社会百态）筛选，或在首页热搜榜查看当前热度最高的事件。",
  },
  {
    q: "站内的热度数据可靠吗？",
    a: "热度与讨论量为各平台公开数据的估算值，主要用于反映事件的相对关注度，不代表精确统计。我们会定期校准算法，并在榜单页注明统计口径与更新时间。",
  },
  {
    q: "如何订阅某件事的最新进展？",
    a: "每篇事件的详情页都提供「持续跟进」入口，事件有重大更新时会汇总到新的动态节点。你可以将感兴趣的话题加入关注，便于回访查看最新时间线。",
  },
  {
    q: "发现站内信息有误怎么办？",
    a: "信息更新快、出错难免。如果你发现我们梳理的时间线或引用与事实不符，欢迎通过站内留言或邮箱告诉我们，经核实后会尽快更正并标注修订记录。",
  },
];